<template>
  <modal
    class="follow-modal"
    name="follow"
    :width="mobile ? '100%' : 636"
    :height="mobile ? height : 646"
    :pivot-x="mobile ? 0 : .5"
    :pivot-y="mobile ? 0 : .5"
    :adaptive="true"
    @opened="opened"
    @closed="closed">
    <div class="p-4 d-flex flex-column h-100">
      <!-- Tabs / Tab switcher -->
      <div
        class="d-flex border-bottom follow-modal__header mb-4">
        <div
          class="follow-modal__header__tab"
          :class="{'follow-modal__header__tab--active': activeTab === 1}"
          @click="activeTab = 1"
        >
          <span class="d-none d-md-inline">Refine by</span> Topic
        </div>
        <div
          class="follow-modal__header__tab"
          :class="{'follow-modal__header__tab--active': activeTab === 3}"
          @click="activeTab = 3"
        >
          Notifications
        </div>
      </div>

            <!-- Content -->
      <div
        class="follow-modal__content"
        style="flex: 1;overflow-y: auto;overflow-y: visible;">
        <!-- Refine by topic - TAB 1 -->
        <div
          v-show="activeTab === 1"
          class="follow-modal__tab follow-modal__refine-tab"
          style="overflow: visible;"
        >
          <div class="follow-modal__refine-tab__header mb-3">
            <span><strong>Add</strong> or <strong>Exclude</strong> content topics <span class="d-none d-inline-md">to refine your alerts</span></span>
          </div>

          <div
            v-if="tag"
            class="follow-modal__input">
            <div
              class="mb-2 d-flex follow-modal__input__element"
            >
              <div class="follow-modal__input__icon" />

              <div class="w-100">
                <input
                  disabled
                  type="text"
                  class="form-control w-100 px-3"
                  v-model="tag.name"
                >
              </div>

            </div>
            <div
              v-for="(input, index) in inputs"
              :key="index"
              class="mb-2 mt-md-0 mt-3 d-block d-md-flex follow-modal__input__element"
            >
              <div class="follow-modal__input__icon">
                <icon
                  v-if="!input.isExclusion"
                  icon="plus"
                />
                <icon
                  v-if="input.isExclusion"
                  icon="minus"
                />
              </div>

              <select
                class="custom-select"
                :class="{'w-100': mobile}"
                v-model="input.isExclusion"
              >
                <option :value="false">Include</option>
                <option :value="true">Exclude</option>
              </select>

              <div
                class="d-flex mt-2 mt-md-0"
                style="flex: 1">
                <form-select
                  style="width: 100%;"
                  :async="true"
                  searchable
                  v-model="input.tag"
                  :options="searchOptions"
                  :placeholder="mobile ? 'Topic' : 'Type to select a topic'"
                  @changed="getAlgoliaTags"
                />

                <button
                  @click="removeInput(index)"
                  class="btn btn-outline-primary follow-modal__remove-btn ml-2">

                  <icon icon="remove" />
                </button>
              </div>


            </div>

            <div class="d-flex follow-modal__input__element">
              <button
                class="btn btn-outline-blue mr-1 btn-bold p-2"
                style="width: 50%;font-size: 16px;"
                @click="addInput(false)"
              >
                + Include topics
              </button>
              <button
                class="btn btn-outline-blue ml-1 btn-bold p-2"
                style="width: 50%;font-size: 16px;"
                @click="addInput(true)"
              >
                - Exclude topics
              </button>
            </div>
          </div>
        </div>



        <!-- Notifications - TAB 3 -->
        <div
          v-show="activeTab === 3"
          class="follow-modal__tab follow-modal__settings-tab"
        >
          <div>
            <div class="d-flex flex-column">
              <div class="mb-3 align-items-center">
                <div class="mr-3">Notification type</div>

                <div class="custom-control custom-checkbox my-2">
                  <input
                    type="checkbox"
                    v-model="receiveEmailNotifications"
                    class="custom-control-input"
                    id="email-checkbox">
                  <label
                    class="custom-control-label"
                    for="email-checkbox">
                    Email
                  </label>
                </div>
                <div class="custom-control custom-checkbox my-2">
                  <input
                    type="checkbox"
                    v-model="receiveDesktopNotifications"
                    class="custom-control-input"
                    id="desktop-checkbox">
                  <label
                    class="custom-control-label"
                    for="desktop-checkbox">
                    Desktop
                  </label>
                </div>
                <div class="custom-control custom-checkbox my-2">
                  <input
                    type="checkbox"
                    v-model="receiveWhatsappNotifications"
                    class="custom-control-input"
                    id="whatsapp-checkbox">
                  <label
                    class="custom-control-label"
                    for="whatsapp-checkbox">
                    WhatsApp
                  </label>
                </div>
                <whats-app
                  :axios="axios"
                  :user="user"
                  v-if="receiveWhatsappNotifications"/>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="d-flex align-items-center border-top pt-4">
        <button
          class="btn btn-outline-blue ml-auto"
          @click="$modal.hide('follow')"
        >
          Cancel
        </button>
        <button
          v-if="id"
          class="ml-3 btn btn-outline-danger"
          @click="unfollow"
        >
          Unfollow
        </button>
        <button
          class="ml-3 btn btn-blue"
          @click="save"
        >
          Save
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
// import FormControl from '@/components/FormControl'
// import {mapState} from 'vuex'
// import algolia from '@/algolia'
import WhatsApp from './WhatsApp'

const defaultState = {
  activeTab: 1,
  inputs: [],
  settings: {},
  notify: {},
}

export default {

  components: {
    WhatsApp,
  },
  props: {
    user: {
      required: true,
      type: Object,
    },
    algolia: {
      required: true,
      type: Object,
    },
    axios: {
      required: true,
      type: Function,
    },
    tagId: {
      required: false,
      type: Number,
      default: null,
    },
    currentFollow: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data () {
    return {
      ...defaultState,
      tag: null,
      mobile: false,
      height: null,
      searchOptions: [],
      id: null,
      receiveEmailNotifications: true,
      receiveWhatsappNotifications: false,
      receiveDesktopNotifications: true,
    }
  },
  computed: {
    saveData () {
      return {
        tagId: this.tag.id,
        includedTags: this.inputs.filter((input) => (input.tag && !input.isExclusion)).map((input) => ({
          id: input.tag.objectID || input.tag.id,
        })),
        excludedTags: this.inputs.filter((input) => (input.tag && input.isExclusion)).map((input) => ({
          id: input.tag.objectID || input.tag.id,
        })),
        receiveEmailNotifications: this.receiveEmailNotifications,
        receiveDesktopNotifications: this.receiveDesktopNotifications,
        receiveWhatsappNotifications: this.receiveWhatsappNotifications,
        contentTypes: this.contentTypes,
        userId: this.user.id,
      }
    },
  },

  watch: {
    currentFollow() {
      this.propagateData()
    },
  },

  async mounted () {
    this.propagateData()
    this.resized()
    window.addEventListener('resize', this.resized)
  },

  methods: {
    propagateData() {
      if (!this.currentFollow) {
        return this.resetData()
      }

      this.tag = this.currentFollow.tag
      this.inputs = this.currentFollow.followTags
      this.id = this.currentFollow.id
      this.receiveDesktopNotifications = this.currentFollow.receiveDesktopNotifications
      this.receiveEmailNotifications = this.currentFollow.receiveEmailNotifications
      this.receiveWhatsappNotifications = this.currentFollow.receiveWhatsappNotifications
    },

    resetData() {
      this.id = null
      this.inputs = []
      this.receiveDesktopNotifications = true
      this.receiveEmailNotifications = true
      this.receiveWhatsappNotifications = false
    },

    convertToJustId (cts) {
      return cts.map((ct) => ({
        id: ct.id,
      }))
    },
    async opened () {
      this.activeTab = 1
      if (this.tagId) {
        const {data} = await this.axios.get(`cms/tags/${this.tagId}`)
        this.tag = data.data
      }
      document.body.style.overflow = 'hidden'
      this.resized()
    },

    closed () {
      document.body.style.overflow = 'auto'
    },

    reset () {
      this.id = null
      this.contentTypes = this.defaultContentTypes()
      this.inputs = []
      this.receiveDesktopNotifications = true
      this.receiveEmailNotifications = true
      this.receiveWhatsappNotifications = false
    },

    addInput (isExclusion) {
      this.inputs.push({
        isExclusion,
        tag: null,
      })
    },

    getAlgoliaTags (query) {
      const index = this.algolia.initIndex('tags')
      index.search(query, (e, content) => {
        this.searchOptions = content.hits
      })
    },

    removeInput (index) {
      this.inputs = this.inputs.filter((input, i) => index !== i)
    },

    async save () {
      const method = this.id ? 'put' : 'post'
      const url = this.id ? `crm/follows/${this.id}` : `crm/follows`

      try {
        const {data} = await this.axios[method](url, this.saveData)
        if (method === 'post') {
          this.$emit('followed', data.data)
        } else {
          this.$emit('updated', data.data)
        }
        this.$modal.hide('follow')
      } catch (e) {
        this.$emit('unable-to-follow', this.tag)
      }
    },

    async unfollow () {
      try {
        const response = await this.axios.delete(`crm/follows/${this.id}`)
        this.$emit('unfollowed', response.data.data)
        this.$modal.hide('follow')
      } catch (e) {
        this.$emit('unable-to-unfollow', this.tag)
      }
    },

    resized () {
      this.mobile = document.body.offsetWidth < 768
      if (this.mobile) {
        const selection = document.querySelector('[data-modal=follow] .v--modal')
        if (selection) {
          selection.style.height = `${document.body.offsetHeight}px`
        }
      }
    },
  },
}
</script>


<style lang="scss">
  $blue: #0080a8;


  .pseudo {
    @media(min-width: 768px) {
      content: '';
      background: gray;
      position: absolute;
    }
  }


  .follow-modal {
    font-size: 16px;
    font-family: "Whyte", "Maison Neue", Helvetica, Roboto, Arial, sans-serif;
    &__remove-btn {
      padding: 0.532rem 1rem;
      .i {
        top: -1px;
      }
      border-color: #e7e7e7 !important;
      color: #757575 !important;
      &:hover {
        color: #7c7c7c !important;
        background: white !important;
        border: 1px solid #757575 !important;
      }
    }

    &__header {
      &__tab {
        margin-bottom: -1px;
        cursor: pointer;
        font-size: 18px;
        margin-right: 1rem;
        padding-bottom: 1rem;
        &--active {
          color: $blue;
          border-bottom: 2px solid $blue;
        }
      }
    }

    &__list {
      margin-top: -1rem;


      @media(min-width: 768px) {

        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        max-height: 460px;
      }
    }


    &__input {
      @media(min-width: 768px) {
        margin-left: 2rem;
      }
      padding-bottom: 1rem;

      &__element {
        position: relative;

        .follow-modal__input__icon {
          color: white;
          position: absolute;
          left: -28px;
          top: 5px;
          z-index: 2;

          .i {
            width: 0.5rem;
            height: 0.5rem;
          }
        }

        .follow__input {
          height: 40px;
          background: #fbfbfd;
          color: #1f2638;
          border: 1px solid #dfe2ee;
          border-radius: 4px;
        }

        .custom-select {
          width: 122px;
          height: 40px;
          margin-right: 8px;
        }

        &:before {
          @extend .pseudo;
          @media(min-width: 768px) {

            height: 1rem;
            width: 1rem;
            left: -2rem;
            top: 12px;
            border-radius: 50%;
          }
        }

        &:after {
          @extend .pseudo;
          @media(min-width: 768px) {
            height: 48px;
            width: 2px;
            left: calc(7px - 2rem);
            top: 0px;
          }
        }

        // First element
        &:first-child {
          &:before {
            @media(min-width: 768px) {
              left: -2rem;
              top: 12px;
            }
          }

          &:after {
            @media(min-width: 768px) {
              height: 28px;
              width: 2px;
              left: calc(7px - 2rem);
              top: 20px;
            }
          }
        }

        // Last element
        &:last-child {
          &:before {
            @media(min-width: 768px) {
              content: '';
              left: -2rem;
              top: 12px;
              background: white;
              border: 2px solid gray;
              z-index: 1;
            }
          }

          &:after {
            @media(min-width: 768px) {
              height: 20px;
              width: 2px;
              left: calc(7px - 2rem);
              top: 0;
            }
          }
        }
      }
    }
  }

</style>

